import { Outlet } from 'react-router';

import { Navigate } from '@sorare/routing';
import { ANY_SPORT_SERIES_PLAY } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { RequireAuth } from '@sorare/core/src/routing/RequireAuth';

import { useIsSquadEnabled } from '#src/hooks/squad/useIsSquadEnabled.ts';

const SeriesSquadLayout = () => {
  const { generateSportContextPath } = useSportContext();
  const isSquadEnabled = useIsSquadEnabled();

  if (!isSquadEnabled) {
    return (
      <Navigate
        to={generateSportContextPath(ANY_SPORT_SERIES_PLAY)}
        replace
        keepSearchParams
      />
    );
  }
  return (
    <RequireAuth>
      <Outlet />
    </RequireAuth>
  );
};

export default SeriesSquadLayout;
